import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import "./About.css";
import openMapLocation from "../utils/navigateLocation";
import { useApiQuery, resolveFileUrl } from "../api/client";
const facts = [
  { label: "Floors", value: "25+" },
  { label: "Units", value: "120+" },
  { label: "Amenities", value: "15+" },
  { label: "Possession", value: "Q4 2027" },
];

const About = () => {
  const { ref, inView } = useInView({ threshold: 0.15, triggerOnce: true });
  const { data: elevationDoc } = useApiQuery("/documents/elevation");
  const elevationUrl = elevationDoc?.fileUrl ? resolveFileUrl(elevationDoc.fileUrl) : "";

  return (
    <section className="about" id="about" ref={ref}>
      <div className="about__container">
        <div className="about__grid">
          {/* Left: media */}
          <motion.div
            className="about__media"
            initial={{ opacity: 0, y: 16 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7 }}
            style={
              elevationUrl ? { backgroundImage: `url(${elevationUrl})` } : undefined
            }
          >
            {/* Replace this placeholder with your image later */}
            <div className="about__mediaInner">
              <div className="about__mediaTag">Project Preview</div>
              {/* <div className="about__mediaTitle">
                A premium living experience
              </div> */}
            </div>
          </motion.div>

          {/* Right: content */}
          <motion.div
            className="about__content"
            initial={{ opacity: 0, y: 16 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.08 }}
          >
            <div className="about__kicker">PROJECT OVERVIEW</div>
            <h2 className="about__title">
              Built to feel calm, modern, and secure.
            </h2>
            <p className="about__text">
              This high-rise is designed for people who want comfort without
              compromise. Spacious layouts, quality finishes, smart security,
              and amenities that actually fit your lifestyle — all in a location
              that stays connected.
            </p>

            <div className="about__actions">
              <button
                onClick={() => {
                  const residence = document.getElementById("residences");
                  residence.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }}
                className="about__btn about__btn--primary"
              >
                Explore Residences <ArrowOutwardRoundedIcon />
              </button>
              <button onClick={()=>{
                openMapLocation()
              }} className="about__btn about__btn--ghost">
                See Location Map <ArrowOutwardRoundedIcon />
              </button>
            </div>

            {/* Facts */}
            {/* <div className="about__facts">
              {facts.map((f, idx) => (
                <div className="about__fact" key={idx}>
                  <div className="about__factValue">{f.value}</div>
                  <div className="about__factLabel">{f.label}</div>
                </div>
              ))}
            </div> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
